module.exports = __webpack_public_path__ + "img/Add Icon - charcoal.68c915c6.svg";